
export const COMPONENT_OPTION = ["Earning","Deduction"];
export const COMPONENT_TYPE = ["Fixed","Variable"];
export const COMPONENT_TYPE_FORMULA = ["Fixed","Variable","Formula"];
export const FORMULA = "Formula";

export const DEFAULT_SUPERANNUATION_VALUE = 9.5;
export const DEFAULT_DEDUCTION_TYPE = 'pretaxdeduction';

export const AMOUNT_TYPE = {
    FIXED: 'FIXED',
    VARIABLE: 'VARIABLE'
};

export const IN_CONFIGURE_AMOUNT_BASED_ON = [
  { id: 'percentageOfBasicSalary', name: 'Percentage of Basic'},
  { id: 'percentageOfSpecificComponent', name: 'Percentage of a Specific Component'},
  { id: 'amountPerDay', name: 'Amount per day for the days worked'},
  { id: 'percentageOfCTC',name: 'Percentage of CTC'}
];
export const CONFIGURE_AMOUNT_BASED_ON = [
    { id: 'percentageOfBasicSalary', name: 'Percentage of Basic Salary'},
    { id: 'percentageOfSpecificComponent', name: 'Percentage of a Specific Component'},
    { id: 'amountPerDay', name: 'Amount per day for the days worked'}
];

export const TAX_DEDUCTION_TYPE = {
    PRE_TAX_DEDUCTION: 'pretaxdeduction',
    POST_TAX_DEDUCTION: 'posttaxdeduction'
};

export const MONTHS = [
    { id: 'jan', name: 'January' },
    { id: 'feb', name: 'February' },
    { id: 'mar', name: 'March' },
    { id: 'apr', name: 'April' },
    { id: 'may', name: 'May' },
    { id: 'jun', name: 'June' },
    { id: 'jul', name: 'July' },
    { id: 'aug', name: 'August' },
    { id: 'sep', name: 'September' },
    { id: 'oct', name: 'October' },
    { id: 'nov', name: 'November' },
    { id: 'dec', name: 'December' }
];

export const QUARTERS = [
    { id: 'q1', name: 'January, February, March (Q1)' },
    { id: 'q2', name: 'April, May, June (Q2)' },
    { id: 'q3', name: 'July, August, September (Q3)' },
    { id: 'q4', name: 'October, November, December (Q4)' }
];

export const MONTHLY_WHEN = [
    { id: 'startOfMonth', name: 'Start of the month' },
    { id: 'endOfMonth', name: 'End of the month' }
];

export const QUARTERLY_WHEN = [
    { id: 'startOfQuarter', name: 'Start of the quarter' },
    { id: 'endOfQuarter', name: 'End of the quarter' }
];

export const YEARLY_WHEN = [
    { id: 'startOfYear', name: 'Start of the year' },
    { id: 'endOfYear', name: 'End of the year' }
];

export const CUSTOM_WHEN = 'CUSTOM_WHEN';

export const COMPONENT_FREQUENCY_TYPE = {
    EVERY_PAYRUN: 'everyPayrun',
    MONTHLY: 'monthly',
    QUARTERLY: 'quarterly',
    YEARLY: 'yearly',
    CUSTOM: 'customDate'
}
export const COMPONENT_FREQUENCY_TYPE_LIST = [
    {id: 'everyPayrun',name:"Every Payrun"},
    {id: 'monthly' , name: "Monthly"},
    {id: 'quarterly', name: "Quarterly"},
    {id: 'yearly' , name:"Yearly"},
    {id: 'customDate', name: "Custom Date"}
]

export const COMPONENT_FREQUENCIES: any[] = [
    {
        id: COMPONENT_FREQUENCY_TYPE.EVERY_PAYRUN,
        name: 'Every Payrun',
        range: null,
        when: null
    },
    {
        id: COMPONENT_FREQUENCY_TYPE.MONTHLY,
        name: 'Monthly',
        range: MONTHS,
        when: MONTHLY_WHEN
    },
    {
        id: COMPONENT_FREQUENCY_TYPE.QUARTERLY,
        name: 'Quarterly',
        range: QUARTERS,
        when: QUARTERLY_WHEN
    },
    {
        id: COMPONENT_FREQUENCY_TYPE.YEARLY,
        name: 'Yearly',
        range: null,
        when: YEARLY_WHEN
    },
    {
        id: COMPONENT_FREQUENCY_TYPE.CUSTOM,
        name: 'Custom Pay Date',
        range: null,
        when: CUSTOM_WHEN
    }
];
export const defaultOtherComponents = ['Bonus', 'Commission', 'Transport Allowance'];
export const INDefaultComponents = ['basic_salary', 'hra', 'fixed_allowance', 'conveyance_allowance'];
export const FORMULA_COMPONENT_LIST = [
    {
        columnCode: "index",
        editable: false,
        hidden: false,
        id: "index",
        index: 0,
        name: "Id",
        options: null,
        required: false,
        systemField: true,
        type: "text",
        uiVisible: true,
        width: 50
    },
    {
        columnCode: "componentId",
        editable: true,
        hidden: false,
        id: "componentId",
        index: 1,
        name: "Earning/Deduction",
        options: [],
        required: true,
        systemField: true,
        type: "select",
        uiVisible: true,
        allowAddOption: false,
        width: 170
    },
    {
        columnCode: "percentage",
        editable: true,
        hidden: false,
        id: "Percentage",
        index: 2,
        name: "Percentage (%)",
        options: null,
        required: true,
        systemField: true,
        type: "number",
        uiVisible: true,
        width: 140
    }
]